import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signature-form-data signature-form-patient-relationship" }

import { SignatureDocumentFieldType } from '@/store/enums';
import {onMounted, Ref, ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientRelationship.vue3',
  props: {
    documentIndex: {},
    fieldIndex: {}
  },
  setup(__props: any) {

const props = __props;

const value = ref('');

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) =>
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});
onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Relationship, value})
);

return (_ctx: any,_cache: any) => {
  const _component_p_input_text = _resolveComponent("p-input-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_p_input_text, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      placeholder: "Relationship to Patient",
      val: value.value
    }, null, 8, ["modelValue", "val"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(value.value), 1)
  ]))
}
}

})